module.exports = __webpack_public_path__ + "static/img/xscjxtv1.5593a77.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/xscjxtv1.png
// module id = wO0C
// module chunks = 1